module.exports = __webpack_public_path__ + "static/media/1-4.2ba5c077.jpg";